// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Macedonia from '../_raw/flag/icon_flag_macedonia.png';

export default () => <img src={Macedonia} alt="Macedonia" />;
